import React from 'react';
import { Upload } from 'lucide-react';

const Contact = () => {
    return (
        <div className="section container">
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h1 style={{ marginBottom: '1rem' }}>Nous Contacter</h1>
                    <p style={{ color: 'var(--text-light)', fontSize: '1.1rem' }}>
                        Remplissez le formulaire ci-dessous pour toute demande de transport ou devis.
                    </p>
                </div>

                <div className="form-container-inner" style={{ backgroundColor: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px -5px rgba(0,0,0,0.05)' }}>
                    <form
                        action="https://formspree.io/f/xzdadyrd"
                        method="POST"
                        encType="multipart/form-data"
                        className="contact-form"
                    >
                        {/* Section: Civilité & Identité */}
                        <div className="form-section">
                            <label className="section-label">Civilité</label>
                            <div className="radio-group">
                                <label className="radio-label">
                                    <input type="radio" name="civilite" value="Monsieur" className="radio-input" />
                                    <span className="radio-custom"></span>
                                    Monsieur
                                </label>
                                <label className="radio-label">
                                    <input type="radio" name="civilite" value="Madame" className="radio-input" />
                                    <span className="radio-custom"></span>
                                    Madame
                                </label>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Nom</label>
                                <input type="text" name="nom" className="form-input" placeholder="Votre nom" />
                            </div>
                            <div className="form-group">
                                <label>Prénom</label>
                                <input type="text" name="prenom" className="form-input" placeholder="Votre prénom" />
                            </div>
                        </div>

                        {/* Section: Informations Assuré */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>Date de naissance du transporté</label>
                                <input type="date" name="date_naissance" className="form-input" />
                            </div>
                            <div className="form-group">
                                <label>Adresse de l'assuré (parents)</label>
                                <input type="text" name="adresse_assure" className="form-input" placeholder="Adresse complète" />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Nom de Caisse Sécurité sociale</label>
                                <input type="text" name="caisse_secu" className="form-input" />
                            </div>
                            <div className="form-group">
                                <label>N° Sécurité sociale du parent</label>
                                <input type="text" name="secu_parent" className="form-input" />
                            </div>
                            <div className="form-group">
                                <label>N° Sécurité sociale</label>
                                <input type="text" name="secu_transport" className="form-input" />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Nom et N° de la mutuelle</label>
                                <input type="text" name="mutuelle" className="form-input" />
                            </div>
                            <div className="form-group">
                                <label className="section-label">Type de Sécurité Sociale</label>
                                <div className="radio-group vertical">
                                    <label className="radio-label"><input type="radio" name="type_secu" value="AME" /> AME</label>
                                    <label className="radio-label"><input type="radio" name="type_secu" value="ALD" /> ALD</label>
                                    <label className="radio-label"><input type="radio" name="type_secu" value="CMU" /> CMU</label>
                                    <label className="radio-label"><input type="radio" name="type_secu" value="Mutuelle" /> Mutuelle</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Numéro d'Accident du travail</label>
                                <input type="text" name="accident_travail" className="form-input" />
                            </div>
                        </div>

                        <hr className="form-divider" />

                        {/* Section: Transport */}
                        <div className="form-row">
                            <div className="form-group">
                                <label className="section-label">Type de transport</label>
                                <div className="radio-group vertical">
                                    <label className="radio-label"><input type="radio" name="type_transport" value="Scolaire" /> Scolaire</label>
                                    <label className="radio-label"><input type="radio" name="type_transport" value="Divers" /> Divers</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="section-label">Type de siège pour enfant</label>
                                <div className="radio-group vertical">
                                    <label className="radio-label"><input type="radio" name="siege" value="Rehausseur" /> Réhausseur</label>
                                    <label className="radio-label"><input type="radio" name="siege" value="Siege bebe" /> Siège pour bébé</label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="section-label">A/R Trajet</label>
                            <div className="radio-group">
                                <label className="radio-label"><input type="radio" name="trajet" value="Aller simple" /> Aller simple</label>
                                <label className="radio-label"><input type="radio" name="trajet" value="Aller-Retour" /> Aller-Retour</label>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Date du transport</label>
                            <input type="date" name="date_transport" className="form-input" />
                        </div>

                        {/* Adresses */}
                        <div className="form-section">
                            <label>Adresse de départ</label>
                            <input type="text" name="depart_rue" className="form-input mb-2" placeholder="Rue" />
                            <div className="form-row">
                                <input type="text" name="depart_ville" className="form-input" placeholder="Ville" />
                                <input type="text" name="depart_dept" className="form-input" placeholder="Département" />
                                <input type="text" name="depart_cp" className="form-input" placeholder="Code Postal" />
                            </div>
                        </div>

                        <div className="form-section">
                            <label>Adresse de destination</label>
                            <input type="text" name="dest_rue" className="form-input mb-2" placeholder="Rue" />
                            <div className="form-row">
                                <input type="text" name="dest_ville" className="form-input" placeholder="Ville" />
                                <input type="text" name="dest_dept" className="form-input" placeholder="Département" />
                                <input type="text" name="dest_cp" className="form-input" placeholder="Code Postal" />
                            </div>
                        </div>

                        {/* Horaires */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>Heure d'arrivée au RDV</label>
                                <input type="time" name="heure_arrivee" className="form-input" />
                            </div>
                            <div className="form-group">
                                <label>Heure de retour</label>
                                <input type="time" name="heure_retour" className="form-input" />
                            </div>
                        </div>

                        <hr className="form-divider" />

                        {/* Documents */}
                        <div className="form-row" style={{ alignItems: 'stretch' }}>
                            <FileUpload label="Prescription médicale de transport" name="file_prescription" />
                            <FileUpload label="Attestation carte vitale" name="file_vitale" />
                            <FileUpload label="Emploi du temps de l'enfant" name="file_emploidutemps" />
                        </div>

                        <button type="submit" className="btn btn-primary" style={{ marginTop: '2rem', padding: '1rem 2rem', fontSize: '1.1rem', width: '100%' }}>
                            Envoyer
                        </button>
                    </form>
                </div>
            </div>

            <style>{`
                .contact-form { display: flex; flex-direction: column; gap: 2rem; }
                /* Desktop: responsive grid */
                .form-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1.5rem; }
                
                /* Mobile: force single column */
                @media (max-width: 768px) {
                    .form-row { display: flex !important; flex-direction: column !important; gap: 1rem; }
                    .radio-group { flex-wrap: wrap; }
                    .contact-form { gap: 1.5rem; }
                    /* Adjust padding inside the white box */
                    .form-container-inner { padding: 1.5rem !important; }
                }

                .form-group { display: flex; flex-direction: column; gap: 0.5rem; }
                .form-input { 
                    padding: 0.875rem; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 8px; 
                    font-size: 0.95rem; 
                    width: 100%;
                    outline: none;
                    transition: border-color 0.2s;
                    box-sizing: border-box; /* Crucial for responsive width */
                }
                .form-input:focus { border-color: var(--primary-color); }
                .form-divider { border: 0; border-top: 1px solid #f1f5f9; margin: 1rem 0; }
                .mb-2 { margin-bottom: 0.75rem; }
                
                label { font-weight: 500; font-size: 0.95rem; color: #334155; }
                
                .radio-group { display: flex; gap: 1.5rem; }
                .radio-group.vertical { flex-direction: column; gap: 0.5rem; }
                .radio-label { display: flex; alignItems: center; gap: 0.5rem; cursor: pointer; color: #475569; }
                
                .file-upload-box {
                    border: 2px dashed #cbd5e1;
                    border-radius: 12px;
                    padding: 2rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    min-height: 150px; /* Ensure height on desktop */
                    background-color: #f8fafc;
                }
                .file-upload-box:hover { border-color: var(--primary-color); background-color: #f0f9ff; }
            `}</style>
        </div>
    );
};

const FileUpload = ({ label, name }) => (
    <div style={{ flex: 1 }}>
        <label style={{ display: 'block', marginBottom: '0.75rem' }}>{label}</label>
        <div className="file-upload-box">
            <Upload size={24} style={{ color: '#64748b', marginBottom: '0.75rem' }} />
            <span style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '0.5rem' }}>
                Déposer un fichier ici ou cliquer pour télécharger
            </span>
            <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Taille de fichier maximale : 6MB</span>
            <input type="file" name={name} style={{ display: 'none' }} />
        </div>
    </div>
);

export default Contact;
